module.exports = __webpack_public_path__ + "img/map-panel-location-icon.c5794ae0.svg";